{
  "pt": {
    "issue_list": {
      "actions": {
        "add_units": "Unidades",
        "all_units_assigned": "Todas as unidades atribuídas",
        "change_responsible": "Alterar responsável",
        "check": "Verificar",
        "create_issue_lists": "Criar lista de reclamações | Criar listas de reclamações",
        "delete": "Apagar",
        "delete_count": "Está prestes a eliminar os obstáculos da unidade {count}. Tem a certeza? | Está prestes a apagar os snags das unidades {count}. Tem certeza?",
        "delete_issue_lists": "Eliminar problemas",
        "edit": "Editar",
        "edit_issue_list": "Editar o tipo de lista de obstáculos",
        "export": "Exportação",
        "generatePDF": "Gerar PDF",
        "go_to_summary": "Ir para o resumo",
        "new": "Problema",
        "new_customer": "Comunicar defeito",
        "new_issue_list": "Lista de obstáculos",
        "selectAll": "Selecionar todas as listas {total} ",
        "unSelectAll": "Limpar seleção",
        "update": "Atualização"
      },
      "attributes": {
        "date": "Data de início",
        "description": "Descrição",
        "name": "Nome"
      },
      "labels": {
        "aftercare_conversations": "Conversas sobre cuidados posteriores",
        "aftercare_conversations_go_to_settings": "Ir para definições",
        "aftercare_conversations_not_enabled": "As conversas no âmbito dos cuidados posteriores ainda não estão ativadas. Pode ativá-las nas definições da sua empresa.",
        "aftercare_conversations_toggle": "Permitir conversas no âmbito dos cuidados posteriores",
        "assign_to_list": "Atribuir à lista",
        "collapse_all": "Recolher",
        "completed_header": "{completed_count} fora de {issues_count} obstáculos concluídos",
        "customer": "Cliente",
        "date": "Data de início (facultativo)",
        "delete_explanation": "Todos os obstáculos, juntamente com as suas imagens e documentos, serão removidos permanentemente da plataforma.",
        "description_title": "Adicionar uma descrição",
        "deselect_all": "Desmarcar tudo",
        "edit_multiple": "Editar {count} listas de problemas",
        "hide_count": "Anular a publicação de problemas para 1 unidade | Anular a publicação de problemas para {count} unidades",
        "hide_count_SUP": "Anular a publicação de problemas",
        "issue_list": "Lista de reclamações",
        "issue_lists": "Listas de captura",
        "issue_lists_all_projects": "Acompanhamento de todos os projectos",
        "issues_count": "Trincos",
        "no_issues_to_export": "Sem problemas para exportar",
        "no_lists_completed": "Não foram preenchidas listas",
        "open_all": "Abrir",
        "partners": "Parceiros",
        "pdf_generated_successfully": "PDF gerado com sucesso",
        "process_issues": "Processo snag | Processo snags",
        "project_units_total": "{project_name} tem {units_count_max} unidades no total",
        "publish_now": "Publicar agora?",
        "published_count": "Publicar problemas para 1 unidade | Publicar problemas para {count} unidades",
        "published_count_SUP": "Publicar problemas",
        "save_explainer": "Tornar os (futuros) problemas visíveis para os seus clientes? Ou guardar e publicar mais tarde?",
        "selectOne": "Selecionar pelo menos 1 lista",
        "select_all": "Selecionar tudo",
        "selected": "{selected} lista selecionada. | {selected} listas seleccionadas",
        "status": "estatuto",
        "step_1_info": "Por exemplo, entrega preliminar ou final, problemas na cozinha ou nas casas de banho,...",
        "step_1_title": "Que tipo de lista de problemas pretende elaborar?",
        "step_2_subtitle": "Seleccione o seu projeto para incluir todas as suas unidades de uma só vez. Pode sempre adicionar mais unidades mais tarde.",
        "step_2_title": "Para que unidades pretende registar os obstáculos?",
        "tab_issue_list_documents": "Documentos",
        "tab_issue_list_issues": "Trincos",
        "tab_issue_list_issues_customer": "Pós-Venda",
        "tab_issue_list_tickets": "Conversas",
        "tab_issues": "Todos os entalhes",
        "tab_units": "Unidades",
        "totalSelected": "Todas as listas {total} são seleccionadas",
        "you_have_customer_issues": "Tem 1 problema de cliente não processado | Tem {number} problemas de cliente não processados"
      },
      "navigation": {
        "back_to_issue_lists": "De volta às listas de pendências"
      },
      "placeholders": {
        "customers": {
          "new": {
            "subtitle": "Acompanhamento dos obstáculos comunicados",
            "title": "Todos os seus problemas serão mostrados aqui"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Criar obstáculos para as unidades anexadas à lista",
            "title": "Crie a sua primeira lista de problemas"
          }
        },
        "partners": {
          "subtitle": "Será notificado quando forem criados novos obstáculos",
          "title": "Ainda não lhe foram atribuídos obstáculos"
        }
      },
      "validation": {
        "name_already_taken": "O nome já foi escolhido para este projeto.",
        "need_name": "O nome é obrigatório"
      }
    }
  }
}